import React from 'react'
import { motion } from 'framer-motion'
import { usePublicContent } from '../hooks/usePublicContent'
import { AboutContent } from '../types/content'

const TrustStrip: React.FC = () => {
  const { content } = usePublicContent('about')
  const aboutData = content?.data as AboutContent

  const uploadedVenues = aboutData?.venueLogos || []
  const venues = uploadedVenues.length > 0
    ? [...uploadedVenues].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    : []

  if (venues.length === 0) return null

  // If more than 5 logos, use scrolling animation
  const shouldScroll = venues.length > 5

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
      className="absolute bottom-0 left-0 right-0 z-10 py-4 px-4 sm:px-6"
      style={{ background: 'transparent' }}
    >
      <div className="relative overflow-hidden w-full">
        {shouldScroll ? (
          // Scrolling animation for many logos
          <motion.div
            animate={{ x: [`-${venues.length * 160}px`, '0px'] }}
            transition={{
              duration: venues.length * 5,
              repeat: Infinity,
              ease: "linear"
            }}
            className="flex items-center gap-6 sm:gap-8 md:gap-10"
            style={{ width: `${venues.length * 160 * 2}px` }}
          >
            {[...venues, ...venues].map((venue, index) => {
              const VenueContainer = venue.website ? 'a' : 'div'
              const containerProps = venue.website
                ? {
                    href: venue.website,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    className:
                      'flex-shrink-0 h-12 sm:h-14 w-28 sm:w-32 flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity duration-200 cursor-pointer',
                  }
                : {
                    className:
                      'flex-shrink-0 h-12 sm:h-14 w-28 sm:w-32 flex items-center justify-center opacity-70',
                  }

              return (
                <VenueContainer key={`${venue.id}-${index}`} {...containerProps}>
                  {venue.logo?.trim() ? (
                    <img
                      src={venue.logo}
                      alt={venue.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <span className="text-white/80 text-xs sm:text-sm font-medium text-center truncate max-w-full px-1">
                      {venue.name}
                    </span>
                  )}
                </VenueContainer>
              )
            })}
          </motion.div>
        ) : (
          // Static display for few logos
          <div className="flex items-center justify-center gap-6 sm:gap-8 md:gap-10">
            {venues.map((venue) => {
              const VenueContainer = venue.website ? 'a' : 'div'
              const containerProps = venue.website
                ? {
                    href: venue.website,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    className:
                      'flex-shrink-0 h-12 sm:h-14 w-28 sm:w-32 flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity duration-200 cursor-pointer',
                  }
                : {
                    className:
                      'flex-shrink-0 h-12 sm:h-14 w-28 sm:w-32 flex items-center justify-center opacity-70',
                  }

              return (
                <VenueContainer key={venue.id} {...containerProps}>
                  {venue.logo?.trim() ? (
                    <img
                      src={venue.logo}
                      alt={venue.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <span className="text-white/80 text-xs sm:text-sm font-medium text-center truncate max-w-full px-1">
                      {venue.name}
                    </span>
                  )}
                </VenueContainer>
              )
            })}
          </div>
        )}
      </div>
    </motion.div>
  )
}

export default TrustStrip
